import React from 'react';

const PageNotFound = () => {
  return (
    <div>
      <h1 className="server-title">Page Not Found</h1>
      <p className="server-subtitle">The page your are looking for was moved, removed or never existed.</p>
      <br/>
      <div className="server-button"><a href="https://birthdayalarm.com" title="Go Back To Homepage">Go Back To Homepage</a></div>
    </div>
  );
}

PageNotFound.propTypes = {

};

PageNotFound.defaultProps = {

};

export default PageNotFound;
